import { z } from 'zod';

import { EntityId } from '../../BrandedIds';
import { ExportableAddress } from '../util/ExportableAddress';

export const ExportableEntity = z
  .object({
    id: EntityId,

    name: z.string(),
    ein: z.string(),
    address: ExportableAddress,
    phone: z.string(),
    email: z.string(),
  })
  .meta({ title: 'Entity' });
